import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ChevronLeft } from "lucide-react";


import {
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaDirections,
} from "react-icons/fa";
import { GiMedicalPack } from "react-icons/gi";
import {
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";

import tambaramskin from "../../../../assets/images/tambaramskinicon.png";
import tambaramhair from "../../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "../../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "../../../../assets/images/tambarambanner4.png";

import img1 from "../../../../assets/images/autoscroll1.jpg";
import img2 from "../../../../assets/images/autoscroll2.jpg";
import img3 from "../../../../assets/images/autoscroll3.jpg";
import img4 from "../../../../assets/images/autoscroll4.jpg";
import img5 from "../../../../assets/images/autoscroll5.jpg";
import img6 from "../../../../assets/images/autoscroll6.jpg";
import img7 from "../../../../assets/images/autoscroll7.jpg";
import img8 from "../../../../assets/images/autoscroll8.jpg";
import img9 from "../../../../assets/images/autoscroll9.jpg";
import img10 from "../../../../assets/images/autoscroll10.jpg";
import img11 from "../../../../assets/images/autoscrollskin1.png";
import img12 from "../../../../assets/images/autoscrollskin2.png";
import img13 from "../../../../assets/images/autoscrollskin3.png";
import img14 from "../../../../assets/images/autoscrollskin4.png";
import img15 from "../../../../assets/images/autoscrollskin5.png";
import img16 from "../../../../assets/images/autoscrollskin6.png";
import img17 from "../../../../assets/images/autoscrollskin7.png";
import img18 from "../../../../assets/images/autoscrollskin8.png";
import img19 from "../../../../assets/images/autoscrollskin9.png";
import img20 from "../../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "../../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "../../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "../../../../assets/images/chennaitambaramhomeopathy.png";
import chennaitambaramskin1 from "../../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "../../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambarampcos from "../../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "../../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "../../../../assets/images/chennaitambarammentalhealth.jpg";

import chennaivalasaravakkamhair from "../../../../assets/images/chennaivalasaravakkamhair1.jpg";
import chennaivalasaravakkamhair1 from "../../../../assets/images/chennaivalasaravakkamhair2.jpg";
import chennaivalasaravakkamhair2 from "../../../../assets/images/chennaivalasaravakkamhair3.jpg";
import chennaivalasaravakkamhair3 from "../../../../assets/images/chennaivalasaravakkamhair4.jpg";
import chennaivalasaravakkamdental1 from "../../../../assets/images/chennaivalasaravakkamdental1.jpg";
import chennaivalasaravakkamdental2 from "../../../../assets/images/chennaivalasaravakkamdental4.jpg";
import chennaivalasaravakkamdental3 from "../../../../assets/images/chennaivalasaravakkamdental5.jpg";

import hcuraHeroVideo from "../../../../assets/video/hcura-hero2.mp4";
import hcuraHeroVideo1 from "../../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "../../../../assets/video/hcura-hero4.mp4";


import jayanagar1 from './../../../../assets/images/jayanagar12.jpeg' 
import jayanagar2 from './../../../../assets/images/jayanagar11.jpeg' 
import jayanagar3 from './../../../../assets/images/jayanagar3.jpeg' 
import jayanagar4 from './../../../../assets/images/jayanagar4.jpeg' 
import jayanagar5 from './../../../../assets/images/jayanagar5.jpeg' 
import jayanagar6 from './../../../../assets/images/jayanagar6.jpeg' 
import jayanagar7 from './../../../../assets/images/jayanagar7.jpeg' 
import jayanagar8 from './../../../../assets/images/jayanagar13.jpeg' 

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const JayanagarBangalore = () => {
  const [activeLocation, setActiveLocation] = useState("jayanagar");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
   const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const carouselTrackRef = useRef(null);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  const [valasaravakamchennaiBaModalOpen, setTambaramBaModalOpen] = useState(false);
  const [valasaravakamchennaiBaModalItems, setTambaramBaModalItems] = useState([]);
  const [valasaravakamchennaiBaModalStartIndex, setTambaramBaModalStartIndex] = useState(0);

  const Users = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
    <path d="M16 4C18.2 4 20 5.8 20 8S18.2 12 16 12 12 10.2 12 8 13.8 4 16 4M16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14M8 4C10.2 4 12 5.8 12 8S10.2 12 8 12 4 10.2 4 8 5.8 4 8 4M8 14C10.7 14 16 15.3 16 18V20H0V18C0 15.3 5.3 14 8 14Z" />
  </svg>
);

const Stethoscope = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19,8A3,3 0 0,0 16,11C16,12.88 15.27,14.54 14.05,15.72L13.41,14.41C14.21,13.5 14.7,12.3 14.7,11A3,3 0 0,0 11.7,8A3,3 0 0,0 8.7,11C8.7,12.3 9.19,13.5 10,14.41L9.34,15.72C8.12,14.54 7.4,12.88 7.4,11A4.3,4.3 0 0,1 11.7,6.7A4.3,4.3 0 0,1 16,11A3,3 0 0,0 19,8M11.7,1C8.26,1 5.44,3.8 5.4,7.24V11A7.29,7.29 0 0,0 12.7,18.3A7.29,7.29 0 0,0 19.95,11V7.24C19.91,3.8 17.09,1 13.65,1H11.7Z" />
  </svg>
);
const Shield = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11H16V18H8V11H9.2V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.4,8.7 10.4,10V11H13.6V10C13.6,8.7 12.8,8.2 12,8.2Z" />
  </svg>
);
  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (valasaravakamchennaiBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft =
          valasaravakamchennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [valasaravakamchennaiBaModalOpen, valasaravakamchennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  useEffect(() => {
    document.title = "H-Cura | Premier Hair, Skin, Dental & Homeopathy Clinic in Jayanagar, Bengaluru";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Experience world-class hair, skin, dental, and homeopathy care at H-Cura Jayanagar. Our multispecialty clinic in Bengaluru offers personalized clinical excellence and proven results."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "H-Cura Multispecialty Clinic Jayanagar, Bengaluru Homeopathy, Hair restoration Jayanagar, Advanced Dermatology Bengaluru, Digital Dentistry Jayanagar, PCOS Homeopathy Bengaluru, Best clinic Jayanagar 9th block"
      );
    }
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-jayanagar-bangalore/");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-jayanagar-bangalore/");
      document.head.appendChild(canonicalLink);
    }
  }, []);

  useEffect(() => {
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
    });
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    jayanagar: {
      name: "JAYANAGAR",
      address: "No:779 & 780 2rd Floor, Sai Towers Building, South, E End Main Rd, opposite to Metro Pillar No 92, Corporation Colony, Jayanagara 9th Block, Jayanagar, Bengaluru, Karnataka 560041.",
      phone: "+91 99646 88333",
      hours: "Mon - Sun: 10:00 AM - 08:00 PM",
      nearbyAreas: "Jayanagar 9th Block, JP Nagar, BTM Layout, Banashankari, Basavanagudi",
      popularServices: [
        "Advanced Trichology (PRP/GFC)",
        "Medical-Grade Aesthetics",
        "Precision Implantology",
        "Constitutional Homeopathy",
      ],
      specialties: "Hair, Skin, Dental & Homeopathy",
      mapUrl: "https://maps.app.goo.gl/L3vb8RSTzoZvajB47",
      video: hcuraHeroVideo1,
    }
  };

  const advancedServices = [
    {
      id: "hair",
      title: "Advanced Trichology & Hair Restoration Excellence",
      subtitle: "Scientific Solutions for Sustainable Hair Growth.",
      description:
        "At H-Cura Jayanagar, we employ sophisticated trichological protocols to combat alopecia and thinning. Our clinical interventions, including high-concentration PRP, GFC therapy, and QR678, are designed to revitalize dormant follicles and restore natural density through evidence-based methodologies.",
      image: chennaitambarm,
      treatments: [
        {
          name: "Clinical PRP Therapy",
          description: "Utilizing autologous growth factors to stimulate cellular repair and promote robust follicular development.",
          icon: "prp-icon",
          image: chennaivalasaravakkamhair,
          benefits: ["Biostimulation", "Enhanced density", "Minimally invasive", "Zero downtime"],
        },
        {
          name: "GFC (Growth Factor Concentrate)",
          description: "A highly potent, acellular treatment that delivers direct growth factors to the scalp for superior regenerative results.",
          icon: "gfc-icon",
          image: chennaivalasaravakkamhair1,
          benefits: ["Pure growth factors", "Accelerated results", "High efficacy", "Precision care"],
        },
        {
          name: "QR678 Growth Factor",
          description: "An internationally acclaimed, non-surgical hair regrowth therapy utilizing plant-derived biomimetic growth factors.",
          icon: "laser-therapy-icon",
          image: chennaivalasaravakkamhair2,
          benefits: ["Patented technology", "Scalp nourishment", "Proven safety", "Follicular rejuvenation"],
        },
      ],
      testimonial: {
        quote: "The clinical approach to my hair thinning at H-Cura Jayanagar was exceptional. The results are scientifically visible.",
        author: "Arvind S.",
        location: "JP Nagar",
      },
    },
    {
      id: "skin",
      title: "Dermatological Excellence & Aesthetic Skin Transformations",
      subtitle: "Precision Care for Radiant, Healthy Skin.",
      description:
        "Our dermatology department in Jayanagar specializes in advanced skin health management. From treating complex acne and melasma to providing medical-grade aesthetic enhancements, we use FDA-approved technologies to ensure safe and transformative outcomes for all skin types.",
      image: chennaitambarmskin,
      treatments: [
        {
          name: "Medical-Grade HydraFacial",
          description: "A multi-step treatment that cleanses, exfoliates, and extracts impurities while infusing the skin with potent antioxidants.",
          icon: "hydrafacial-icon",
          image: chennaitambaramskin1,
          benefits: ["Deep detoxification", "Hydration boost", "Luminous texture", "Pore refinement"],
        },
        {
          name: "Advanced Laser Therapeutics",
          description: "Targeted laser solutions for pigment correction, scar revision, and skin resurfacing with precision and safety.",
          icon: "pigmentation-icon",
          image: chennaitambaramskin2,
          benefits: ["Tone correction", "Texture improvement", "Collagen induction", "Clinical safety"],
        },
        {
          name: "Anti-Aging Interventions",
          description: "Non-surgical procedures designed to restore facial volume and reduce fine lines for a naturally rejuvenated appearance.",
          icon: "antiaging-icon",
          image: chennaivalasaravakkamhair3,
          benefits: ["Volume restoration", "Wrinkle reduction", "Natural aesthetics", "Expert execution"],
        },
      ],
      testimonial: {
        quote: "Superior skin care standards. The laser treatments for my pigmentation were highly effective and professionally handled.",
        author: "Mrs. Ananya K.",
        location: "BTM Layout",
      },
    },
    {
      id: "dental",
      title: "Comprehensive Dental Care & Smile Design Studio",
      subtitle: "Where Precision Meets Aesthetic Dentistry.",
      description:
        "Our Jayanagar dental facility offers a spectrum of services from preventive care to complex cosmetic reconstructions. We integrate digital dentistry with expert craftsmanship to deliver healthy, functional, and aesthetically pleasing smiles.",
      image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      treatments: [
        {
          name: "Clear Aligner Therapy",
          description: "Orthodontic correction using virtually invisible, custom-designed aligners for optimal comfort and discretion.",
          icon: "aligner-icon",
          image: chennaivalasaravakkamdental1,
          benefits: ["Discreet alignment", "Removable", "Digital planning", "Superior comfort"],
        },
        {
          name: "Micro-Endodontics",
          description: "Precision-driven root canal treatments aimed at preserving natural tooth structure using advanced imaging.",
          icon: "rootcanal-icon",
          image: chennaivalasaravakkamdental2,
          benefits: ["Pain management", "Tooth preservation", "High success rate", "Advanced tech"],
        },
        {
          name: "Cosmetic Smile Enhancement",
          description: "Professional teeth whitening and veneer placements to achieve a bright, symmetrical, and confident smile.",
          icon: "smile-icon",
          image: chennaivalasaravakkamdental3,
          benefits: ["Instant aesthetic", "Safe procedures", "Custom shade matching", "Confidence boost"],
        },
      ],
      testimonial: {
        quote: "The dental team at Jayanagar is highly skilled. My invisible braces treatment was seamless and successful.",
        author: "Vikram R.",
        location: "Banashankari",
      },
    },
    {
      id: "homeopathy",
      title: "Evidence-Based Homeopathic Therapeutics & Wellness",
      subtitle: "Holistic Healing Rooted in Clinical Science.",
      description:
        "H-Cura Jayanagar provides constitutional homeopathy for chronic and systemic health challenges. Our approach focuses on the root cause, offering safe and personalized medicine for PCOS, thyroid disorders, and lifestyle-related conditions.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "Hormonal Health Management",
          description: "Specialized homeopathic protocols for PCOS, PCOD, and thyroid irregularities to restore physiological balance.",
          icon: "hormonal-icon",
          image: chennaitambarampcos,
          benefits: ["Natural regulation", "Metabolic support", "Zero side effects", "Long-term health"],
        },
        {
          name: "Chronic Disease Management",
          description: "Comprehensive care for long-standing conditions like respiratory allergies, skin disorders, and joint pains.",
          icon: "chronic-icon",
          image: chennaitambaramchronic,
          benefits: ["Root-cause focus", "Immune modulation", "Personalized doses", "Holistic recovery"],
        },
        {
          name: "Psychosomatic Wellness",
          description: "Gentle therapeutic interventions for stress-related disorders, anxiety, and insomnia to improve overall quality of life.",
          icon: "constitutional-icon",
          image: chennaitambarammentalhealth,
          benefits: ["Stress reduction", "Better sleep", "Mental clarity", "Safe for all ages"],
        },
      ],
      testimonial: {
        quote: "The homeopathic treatment for my PCOS at H-Cura Jayanagar has been life-changing. Truly holistic care.",
        author: "Ms. Shalini M.",
        location: "Jayanagar",
      },
    },
  ];

  const testimonials = [
    {
      name: "Arvind S.",
      location: "JP Nagar",
      text: "The clinical approach to my hair thinning at H-Cura Jayanagar was exceptional. The results are scientifically visible.",
      rating: 5,
      service: "Hair Restoration",
    },
    {
      name: "Mrs. Ananya K.",
      location: "BTM Layout",
      text: "Superior skin care standards. The laser treatments for my pigmentation were highly effective and professionally handled.",
      rating: 5,
      service: "Dermatology",
    },
    {
      name: "Vikram R.",
      location: "Banashankari",
      text: "The dental team at Jayanagar is highly skilled. My invisible braces treatment was seamless and successful.",
      rating: 5,
      service: "Dental Care",
    },
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Strategic Location",
      description: "Centrally located in Jayanagar 9th Block, providing premium healthcare access to residents of JP Nagar, BTM, and Banashankari.",
      highlight: "Prime Jayanagar",
    },
    {
      icon: <FaUserMd />,
      title: "Specialized Clinicians",
      description: "Our multidisciplinary team comprises experts in Trichology, Dermatology, Aesthetic Dentistry, and Homeopathy.",
      highlight: "Expert Faculty",
    },
    {
      icon: <GiMedicalPack />,
      title: "Clinical Innovation",
      description: "We utilize cutting-edge medical diagnostic and therapeutic equipment to ensure precision in every procedure.",
      highlight: "Advanced Tech",
    },
    {
      icon: <FaHeartbeat />,
      title: "Integrative Wellness",
      description: "Unique integration of modern clinical treatments with traditional homeopathic wisdom for comprehensive patient care.",
      highlight: "Holistic Model",
    },
    {
      icon: <FaAward />,
      title: "Patient Satisfaction",
      description: "A legacy of successful clinical outcomes and high patient trust across Bengaluru's southern suburbs.",
      highlight: "Proven Success",
    },
    {
      icon: <FaRegLightbulb />,
      title: "Bespoke Protocols",
      description: "Every treatment plan is scientifically tailored based on thorough diagnosis and individual health objectives.",
      highlight: "Custom Care",
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Safety & Sterilization",
      description: "Strict adherence to international hygiene standards and medical sterilization protocols for patient safety.",
      highlight: "Global Standards",
    },
    {
      icon: <MdSupportAgent />,
      title: "Continuity of Care",
      description: "Dedicated post-treatment support and regular follow-ups to ensure long-term stability of clinical results.",
      highlight: "Long-term Support",
    },
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair": return "/advanced-grow-hair-treatment";
      case "skin": return "/advanced-hydrafacial-treatment";
      case "dental": return "/dental-treatment";
      case "homeopathy": return "/homeopathy-best-treatments/";
      default: return "/services";
    }
  };

  const servicesBackgroundUrl = "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

  const serviceIconMap = {
    hair: { url: tambaramhair, bgColor: "rgba(255,154,158,0.12)", borderColor: "rgba(255,154,158,0.18)", color: "#ff4d6d" },
    skin: { url: tambaramskin, bgColor: "rgba(255,223,121,0.12)", borderColor: "rgba(255,223,121,0.18)", color: "#ffb400" },
    dental: { url: "https://img.icons8.com/fluency/48/000000/tooth.png", bgColor: "rgba(144,238,144,0.12)", borderColor: "rgba(144,238,144,0.18)", color: "#28a745" },
    homeopathy: { url: tambaramleaf, bgColor: "rgba(135,206,250,0.12)", borderColor: "rgba(135,206,250,0.18)", color: "#0099cc" },
  };

  const treatmentIconMap = {
    "prp-icon": { url: "https://img.icons8.com/fluency/48/000000/syringe.png", bgColor: "rgba(255,140,140,0.06)", borderColor: "rgba(255,140,140,0.12)" },
    "gfc-icon": { url: "https://img.icons8.com/fluency/48/000000/biotech.png", bgColor: "rgba(170,200,255,0.06)", borderColor: "rgba(110,160,255,0.12)" },
    "hydrafacial-icon": { url: "https://img.icons8.com/fluency/48/000000/spa-care.png", bgColor: "rgba(200,255,230,0.06)", borderColor: "rgba(60,200,120,0.12)" },
    "antiaging-icon": { url: "https://img.icons8.com/fluency/48/000000/collagen.png", bgColor: "rgba(220,245,255,0.06)", borderColor: "rgba(80,200,240,0.12)" },
    "pigmentation-icon": { url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png", bgColor: "rgba(250,210,255,0.06)", borderColor: "rgba(220,120,240,0.12)" },
    "aligner-icon": { url: "https://img.icons8.com/fluency/48/000000/braces.png", bgColor: "rgba(230,230,255,0.06)", borderColor: "rgba(140,120,240,0.12)" },
    "smile-icon": { url: "https://img.icons8.com/fluency/48/000000/happy-tooth.png", bgColor: "rgba(200,255,220,0.06)", borderColor: "rgba(80,200,120,0.12)" },
    "rootcanal-icon": { url: "https://img.icons8.com/fluency/48/000000/tooth-cleaning.png", bgColor: "rgba(255,240,200,0.06)", borderColor: "rgba(240,180,60,0.12)" },
    "hormonal-icon": { url: "https://img.icons8.com/fluency/48/000000/hormone.png", bgColor: "rgba(255,230,240,0.06)", borderColor: "rgba(240,160,200,0.12)" },
    "chronic-icon": { url: "https://img.icons8.com/fluency/48/000000/medical-pack.png", bgColor: "rgba(230,255,240,0.06)", borderColor: "rgba(160,240,200,0.12)" },
    "constitutional-icon": { url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png", borderColor: "rgba(160,160,240,0.12)" },
  };

    const SAMPLE_GALLERY = {
    hair: [
      { id: "hair-1", combined: img1, testimonial: { quote: "I was completely bald. After 6 months of PRP treatment, my hair came back!", author: "Rajesh K." } },
      { id: "hair-2", combined: img2, testimonial: { quote: "The bald spot on top of my head is now full of hair.", author: "Amit S." } },
      { id: "hair-3", combined: img3, testimonial: { quote: "My hairline was going back. Now it looks like when I was 20!", author: "Priya M." } },
      { id: "hair-4", combined: img4, testimonial: { quote: "GFC and QR678 treatment gave me natural hair regrowth.", author: "Karthik R." } },
      { id: "hair-5", combined: img5, testimonial: { quote: "Best decision I made. My hair grew back naturally.", author: "Deepak V." } },
      { id: "hair-6", combined: img6, testimonial: { quote: "In just 3 months, I could see more hair on my head.", author: "Anitha L." } },
      { id: "hair-7", combined: img7, testimonial: { quote: "From almost bald to full head of hair. Thank you!", author: "Suresh K." } },
      { id: "hair-8", combined: img8, testimonial: { quote: "My wife is shocked seeing my new hair.", author: "Vikram P." } },
      { id: "hair-9", combined: img9, testimonial: { quote: "My thin hair became thick again.", author: "Ramesh B." } },
      { id: "hair-10", combined: img10, testimonial: { quote: "After trying many places, only H-Cura could solve it.", author: "Mahesh T." } },
    ],
    skin: [
      { id: "skin-1", combined: img11, testimonial: { quote: "Had pimples for years. Now my face is completely clear!", author: "Sneha R." } },
      { id: "skin-2", combined: img12, testimonial: { quote: "HydraFacial removed all my dark spots.", author: "Kavya M." } },
      { id: "skin-3", combined: img13, testimonial: { quote: "The lines on my face are almost gone.", author: "Meera K." } },
      { id: "skin-4", combined: img14, testimonial: { quote: "My skin color became even all over.", author: "Preethi S." } },
      { id: "skin-5", combined: img15, testimonial: { quote: "The brown patches on my face disappeared completely.", author: "Divya L." } },
      { id: "skin-6", combined: img16, testimonial: { quote: "People say I look 5 years younger.", author: "Anjali P." } },
      { id: "skin-7", combined: img17, testimonial: { quote: "All my old pimple marks are gone.", author: "Rohit M." } },
      { id: "skin-8", combined: img18, testimonial: { quote: "The dark circles under my eyes are gone.", author: "Lakshmi V." } },
      { id: "skin-9", combined: img19, testimonial: { quote: "My loose skin became tight without surgery.", author: "Sunita K." } },
      { id: "skin-10", combined: img20, testimonial: { quote: "My whole face changed. Everyone asks what treatment I took.", author: "Ravi S." } },
    ],
  };

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = "";
  };


  

const Award = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M5,16L3,5L8.5,12L12,5L15.5,12L21,5L19,16H5M12,8L10.5,11L12,14L13.5,11L12,8Z" />
  </svg>
);

const CheckCircle = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
  </svg>
);

const ChevronRight = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
  </svg>
);



useEffect(() => {
  const timer = setInterval(() => {
    goToNext();
  }, 3000); // 3000 milliseconds = 3 seconds

  return () => clearInterval(timer);
}, [currentImageIndex]); // Resets the timer whenever the index changes

const goToSlide = (index) => {
  setCurrentImageIndex(index);
  if (carouselTrackRef.current) {
    // Each image is 12.5% of the track (100 / 8 = 12.5)
    carouselTrackRef.current.style.transform = `translateX(-${index * 12.5}%)`;
  }
};

const goToNext = () => {
  // Use % 8 for eight images
  const nextIndex = (currentImageIndex + 1) % 8;
  goToSlide(nextIndex);
};

const goToPrevious = () => {
  // Loop back to index 7 (the 8th image)
  const prevIndex = currentImageIndex === 0 ? 7 : currentImageIndex - 1;
  goToSlide(prevIndex);
};


  return (
    <div className="pondyhcura-hcura-chennai">
      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <video autoPlay muted loop playsInline style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -2 }}>
         <source src={hcuraHeroVideo} type="video/mp4" />
        </video>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))', zIndex: -1 }}></div>
        <div className="tambaram-hcura-hero-content-wrapper">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="tambaram-hcura-primary-title">
            H-Cura Multispecialty Clinic in Jayanagar, Bengaluru
          </motion.h1>
          <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="tambaram-hcura-secondary-title">
            Advanced Clinical Care for Hair, Skin, Dental & Homeopathy
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }} className="tambaram-hcura-description-text">
            H-Cura Multispecialty Clinic stands as a premier destination for holistic and clinical excellence in Jayanagar, Bengaluru. Our facility integrates state-of-the-art medical technology with proven therapeutic approaches to provide comprehensive care in Hair Restoration, Advanced Dermatology, Precision Dentistry, and Holistic Homeopathy. Strategically located in Jayanagar 9th Block, we serve the communities of JP Nagar, BTM Layout, and Banashankari with a commitment to evidence-based medicine and personalized wellness. Whether you are seeking specialized trichology, aesthetic skin solutions, digital dentistry, or natural homeopathic therapeutics, our expert clinicians deliver world-class care designed for sustainable health and visible transformations.
          </motion.p>
          <motion.div className="tambaram-hcura-action-buttons" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
            <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Consultation</Link>
            <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Clinical WhatsApp
            </a>
          </motion.div>
        </div>
      </section>

      <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Clinical Outcomes & Transformations – H-Cura Jayanagar</span>
          <h2>Before & After Treatment Photos</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaArrowRight /></span></div>
          <p className="pondyhcura-section-description">
            At our Jayanagar facility, clinical success is measured by the visible and lasting transformations of our patients. This gallery showcases documented evidence of hair follicular recovery, dermatological skin clearance, and aesthetic dental enhancements achieved through our specialized protocols.
          </p>
        </div>
        <div className="pondyhcura-before-tabs">
          {["hair", "skin"].map((s, idx) => (
            <button key={s} className={`pondyhcura-ba-tab ${activeService === idx ? "active" : ""}`} onClick={() => handleServiceChange(idx)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <div className="pondyhcura-before-carousel-wrapper">
          <div className="pondyhcura-before-carousel" role="list">
            {(() => {
              const svcKey = activeService === 0 ? "hair" : "skin";
              const items = SAMPLE_GALLERY[svcKey] || [];
              return items.map((item, idx) => (
                <article key={item.id} className="pondyhcura-ba-clean-card" role="listitem">
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img src={item.combined} alt={`${item.title} at H-Cura Jayanagar`} className="pondyhcura-ba-clean-image" />
                      <div className="pondyhcura-ba-clean-title"><h4>{item.title}</h4></div>
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button className="pondyhcura-ba-clean-view-btn" onClick={() => openTambaramBaModal(svcKey, idx)}>See more photos</button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      <section id="why-choose" className="pondyhcura-why-choose-enhanced">
        <div className="pondyhcura-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
        </div>
        <div className="pondyhcura-content-wrapper">
          <motion.div className="pondyhcura-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="pondyhcura-section-subtitle">Clinical Excellence</span>
            <h2>Why Choose H-Cura Multispecialty Clinic Jayanagar?</h2>
            <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaShieldAlt /></span></div>
            <p className="pondyhcura-section-description">
              Our Jayanagar clinic represents the pinnacle of multispecialty care, blending scientific precision with a patient-centric philosophy. We prioritize diagnostic accuracy and ethical medical practices to ensure that every patient from South Bengaluru receives the highest standard of clinical care.
            </p>
          </motion.div>
          <motion.div className="pondyhcura-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="pondyhcura-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="pondyhcura-feature-header">
                  <div className="pondyhcura-icon-container">{feature.icon}<div className="pondyhcura-icon-glow"></div></div>
                  <span className="pondyhcura-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
          <div className="pondyhcura-cta-container">
            <h3>Experience the H-Cura Jayanagar Standard</h3>
            <p>Join a community of patients who trust our clinical expertise for their long-term health and aesthetic goals.</p>
            <Link to="/bookconsultation" className="pondyhcura-cta-button">Schedule Your Appointment</Link>
          </div>
        </div>
      </section>

      <section id="services" className="pondyhcura-services-premium-section" ref={sectionRef}>
        <div className={`pondyhcura-services-background ${isVisible ? "visible" : ""}`} style={{ backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed", opacity: isVisible ? 1 : 0 }}></div>
        <div className="pondyhcura-services-container">
          <div className={`pondyhcura-services-header ${isVisible ? "visible" : ""}`}>
            <span className="pondyhcura-services-subtitle">Specialized Care</span>
            <h2>Our Clinical Disciplines at Jayanagar</h2>
            <p className="pondyhcura-services-description">Discover a range of specialized services where medical science meets personalized care. Each discipline at H-Cura Jayanagar is led by experienced clinicians dedicated to your well-being.</p>
          </div>
          <div className={`pondyhcura-services-tabs ${isVisible ? "visible" : ""}`}>
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button key={service.id} className={`pondyhcura-service-tab ${isActive ? "active" : ""}`} onClick={() => handleServiceChange(index)}>
                  <span className={`pondyhcura-tab-icon bright-icon`} style={{ backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: sIcon?.bgColor, borderRadius: "12px", width: "44px", height: "44px", display: "inline-block" }}></span>
                  <span className="pondyhcura-tab-text">{service.id.charAt(0).toUpperCase() + service.id.slice(1)}</span>
                </button>
              );
            })}
          </div>
          <div className={`pondyhcura-service-content-wrapper ${isVisible ? "visible" : ""}`}>
            <div className={`pondyhcura-service-main-content ${isChanging ? "changing" : ""}`}>
              <div className="pondyhcura-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>
                <div className="pondyhcura-service-cta">
                  <Link to="/bookconsultation" className="pondyhcura-service-btn">Consult Our Specialist</Link>
                </div>
              </div>
              <div className="pondyhcura-service-image-container">
                <img src={advancedServices[activeService].image} alt={advancedServices[activeService].title} className="pondyhcura-service-main-image" />
              </div>
            </div>
            <div className="pondyhcura-service-treatments">
              <h4>Specialized Clinical Interventions</h4>
              <div className="pondyhcura-treatments-slider">
                {advancedServices[activeService].treatments.map((treatment, tIndex) => {
                  const tIcon = treatmentIconMap[treatment.icon] || null;
                  return (
                    <div className="pondyhcura-treatment-card" key={tIndex}>
                      <div className="pondyhcura-treatment-image"><img src={treatment.image} alt={treatment.name} /></div>
                      <div className="pondyhcura-treatment-content">
                        <div className="pondyhcura-treatment-icon" style={{ backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: tIcon?.bgColor, width: "56px", height: "56px", borderRadius: "12px" }}></div>
                        <h5>{treatment.name}</h5>
                        <p>{treatment.description}</p>
                        <div className="pondyhcura-treatment-benefits">
                          <h6>Clinical Benefits:</h6>
                          <ul>{treatment.benefits.map((b, i) => <li key={i}><span className="pondyhcura-benefit-icon">✓</span>{b}</li>)}</ul>
                        </div>
                        <div className="pondyhcura-treatment-cta">
                          <Link className="pondyhcura-treatment-learnmore" to={serviceLearnMoreUrl(advancedServices[activeService].id)}>Know More</Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

       <section className="hcura-about-section">
              <div className="hcura-container">
                <div className="hcura-header">
                  <span className="hcura-subtitle">Your Health, Our Priority</span>
                  <h2 className="hcura-title">
                   H-Cura Jayanagar: Bengaluru's Hub for{" "}
                    <span className="hcura-gradient-text">
                     Clinical & Holistic Excellence
                    </span>
                  </h2>
                  <p className="hcura-description">
                   H-Cura Multispecialty Clinic Jayanagar is a state-of-the-art medical facility dedicated to providing South Bengaluru with premium healthcare solutions. Situated in the heart of Jayanagar 9th Block, we bring together a multidisciplinary team of experts to offer a seamless blend of advanced clinical treatments and holistic healing under one roof. 
                    
                    Whether you are seeking scientific hair restoration, dermatological precision, modern digital dentistry, or evidence-based homeopathy, our clinic serves as the premier destination for residents of JP Nagar, BTM Layout, and Banashankari. By integrating cutting-edge diagnostic tools with personalized care protocols, we ensure that every patient receives treatments that are safe, effective, and results-oriented. Experience a new standard of healthcare at H-Cura Jayanagar, designed to help you look, feel, and live your best.
                  </p>
                </div>
      
                <div className="hcura-content-grid">
                  <div className="hcura-stats-container">
                    <div className="hcura-stats-grid">
                      <div className="hcura-stat-card">
                        <div className="hcura-stat-icon">
                          <Users />
                        </div>
                        <div className="hcura-stat-content">
                          <h3>50,000+</h3>
                          <p>Happy Patients</p>
                        </div>
                      </div>
                      <div className="hcura-stat-card">
                        <div className="hcura-stat-icon">
                          <Stethoscope />
                        </div>
                        <div className="hcura-stat-content">
                          <h3>100+</h3>
                          <p>Expert Doctors</p>
                        </div>
                      </div>
                      <div className="hcura-stat-card">
                        <div className="hcura-stat-icon">
                          <Award />
                        </div>
                        <div className="hcura-stat-content">
                          <h3>4.8★</h3>
                          <p>Google Rating</p>
                        </div>
                      </div>
                      <div className="hcura-stat-card">
                        <div className="hcura-stat-icon">
                          <Shield />
                        </div>
                        <div className="hcura-stat-content">
                          <h3>11+</h3>
                          <p>Clinic Branches</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="hcura-image-container">
                    <div className="hcura-image-carousel">
                      <div className="hcura-carousel-track" ref={carouselTrackRef}>
                        <img src={jayanagar1} alt="H-Cura Clinic Interior 1" />
                        <img src={jayanagar2} alt="H-Cura Clinic Interior 2" />
                        <img src={jayanagar3} alt="H-Cura Clinic Interior 3" />
                        <img src={jayanagar4} alt="H-Cura Clinic Interior 4" />
                        <img src={jayanagar5} alt="H-Cura Clinic Interior 5" />
                        <img src={jayanagar6} alt="H-Cura Clinic Interior 6" />
                        <img src={jayanagar7} alt="H-Cura Clinic Interior 7" />
                        <img src={jayanagar8} alt="H-Cura Clinic Interior 8" />
                      </div>
      
                      <button
                        className="hcura-carousel-btn hcura-carousel-prev"
                        onClick={goToPrevious}
                        aria-label="Previous image"
                      >
                        <ChevronLeft />
                      </button>
                      <button
                        className="hcura-carousel-btn hcura-carousel-next"
                        onClick={goToNext}
                        aria-label="Next image"
                      >
                        <ChevronRight />
                      </button>
      
                      {/* <div className="hcura-carousel-dots">
                        {[0, 1, 2, 3, 4].map((index) => (
                          <button
                            key={index}
                            className={`hcura-carousel-dot \${
                              currentImageIndex === index ? "active" : ""
                            }`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to image \${index + 1}`}
                          />
                        ))}
                      </div> */}
      
                      {/* <div className="hcura-carousel-dots">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((index) => (
          <button
            key={index}
            className={`hcura-carousel-dot ${
              currentImageIndex === index ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to image ${index + 1}`}
          />
        ))}
      </div> */}
      
      <div className="hcura-carousel-dots">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((index) => (
          <button
            key={index}
            className={`hcura-carousel-dot ${
              currentImageIndex === index ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to image ${index + 1}`}
          />
        ))}
      </div>
      
      
                    </div>
                  </div>
                </div>
              </div>
            </section>

      <section className="pondyhcura-stats-banner">
        <div className="pondyhcura-stat"><h3>10,000+</h3><p>Clinical Successes</p></div>
        <div className="pondyhcura-stat"><h3>15+</h3><p>Years of Practice</p></div>
        <div className="pondyhcura-stat"><h3>30+</h3><p>Expert Clinicians</p></div>
        <div className="pondyhcura-stat"><h3>5</h3><p>Regional Centers</p></div>
      </section>

      <section id="locations" className="pondyhcura-locations">
        <div className="pondyhcura-section-header">
          <h2>Regional Clinical Center</h2>
          <p>Access premier multispecialty care at our Jayanagar facility</p>
        </div>
        <div className="pondyhcura-location-details">
          <div className="pondyhcura-location-card">
            <div className="pondyhcura-location-header">
              <h3>{locations.jayanagar.name} FACILITY</h3>
              <span className="pondyhcura-specialty-tag">{locations.jayanagar.specialties}</span>
            </div>
            <div className="pondyhcura-location-grid">
              <div className="pondyhcura-location-info">
                <div className="pondyhcura-info-item">
                  <FaMapMarkerAlt />
                  <div>
                    <h4>Postal Address</h4>
                    <p>{locations.jayanagar.address}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaPhone />
                  <div>
                    <h4>Central Registry</h4>
                    <p>{locations.jayanagar.phone}</p>
                  </div>
                </div>
                <div className="pondyhcura-info-item">
                  <FaClock />
                  <div>
                    <h4>Clinical Hours</h4>
                    <p>{locations.jayanagar.hours}</p>
                  </div>
                </div>
              </div>
              <div className="pondyhcura-popular-services">
                <h4>Core Specialties</h4>
                <ul>{locations.jayanagar.popularServices.map((s, i) => <li key={i}><FaCheckCircle /> {s}</li>)}</ul>
                <a href={locations.jayanagar.mapUrl} target="_blank" rel="noopener noreferrer" className="pondyhcura-map-link">Navigate to Clinic <FaArrowRight /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="pondyhcura-testimonials">
        <div className="pondyhcura-section-header">
          <h2>Patient Perspectives</h2>
          <p>Verified experiences from patients who have undergone clinical care at our Jayanagar center:</p>
        </div>
        <div className="pondyhcura-testimonials-grid">
          {testimonials.map((t, index) => (
            <motion.div className="pondyhcura-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <div className="pondyhcura-testimonial-rating">{[...Array(5)].map((_, i) => <FaStar key={i} className="pondyhcura-star-filled" />)}</div>
              <p className="pondyhcura-testimonial-text">"{t.text}"</p>
              <div className="pondyhcura-testimonial-author">
                <h4>{t.name}</h4>
                <p>{t.location} • {t.service}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="appointment" className="pondyhcura-appointment" style={{ position: "relative", overflow: "hidden", color: "#fff" }}>
        <video autoPlay muted loop playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -2 }}><source src={hcuraHeroVideo2} type="video/mp4" /></video>
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))", zIndex: -1 }}></div>
        <div className="pondyhcura-appointment-content">
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>Register for Consultation at Jayanagar</motion.h2>
          <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>Initialize your journey toward clinical wellness and aesthetic restoration. Our specialists are ready to provide expert guidance.</motion.p>
          <div className="pondyhcura-contact-options">
            <div className="pondyhcura-contact-option"><FaPhone /> <span>+91 99646 88333</span></div>
            <div className="pondyhcura-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">Official Portal</a></div>
          </div>
          <div className="pondyhcura-appointment-buttons">
            <Link to="/bookconsultation" className="pondyhcura-primary-button">Book Appointment</Link>
            <a href="https://wa.me/919964688333" className="pondyhcura-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> Clinical Support</a>
          </div>
        </div>
      </section>

      {valasaravakamchennaiBaModalOpen && (
        <div className="pondyhcura-ba-modal" role="dialog" aria-modal="true">
          <div className="pondyhcura-ba-modal-backdrop" onClick={closeTambaramBaModal} />
          <div className="pondyhcura-ba-modal-panel">
            <header className="pondyhcura-ba-modal-header">
              <h3>Clinical Case Study - H-Cura Jayanagar</h3>
              <button className="pondyhcura-ba-modal-close" onClick={closeTambaramBaModal}>×</button>
            </header>
            <div className="pondyhcura-ba-modal-body">
              <div className="pondyhcura-ba-scrollable-container">
                <div className="pondyhcura-ba-scroll-track" id="scrollTrack">
                  <div className="pondyhcura-ba-scrollable-grid" id="scrollableGrid">
                    {valasaravakamchennaiBaModalItems.map((item, index) => (
                      <div key={item.id} className="pondyhcura-ba-scrollable-card">
                        <div className="pondyhcura-ba-scrollable-image-container"><img src={item.combined} alt={item.title} className="pondyhcura-ba-scrollable-image" /></div>
                        <div className="pondyhcura-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="pondyhcura-ba-scrollable-testimonial">"{item.testimonial?.quote || ""}"</p>
                          <div className="pondyhcura-ba-scrollable-author">— {item.testimonial?.author || ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="pondyhcura-ba-scroll-progress"><div className="pondyhcura-ba-progress-bar" id="progressBar"></div></div>
              </div>
              <div className="pondyhcura-ba-enhanced-controls">
                <div className="pondyhcura-ba-nav-buttons">
                  <button className="pondyhcura-ba-nav-btn" id="prevBtn" onClick={() => scrollGallery("prev")}>Previous</button>
                  <button className="pondyhcura-ba-nav-btn" id="nextBtn" onClick={() => scrollGallery("next")}>Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JayanagarBangalore;
